const Ads = () => {
    const init = () => {
        // adsterraPopunder();
    };

    /*
    const adsterraPopunder = () => {
        window.onload = () => {
            const popunderUrl =
                "https://www.highcpmrevenuenetwork.com/r1hc1hjri?key=1f31156e525a25f5a7cd727c95b496b9";
            const popunderTimeShow = Math.round(+new Date() / 1000);

            if (
                typeof localStorage.popunderTimeShow == "undefined" ||
                parseInt(localStorage.popunderTimeShow) <=
                    popunderTimeShow - 3600
            ) {
                const links = document.getElementsByTagName("a");

                for (let i = 0, len = links.length; i < len; i++) {
                    links[i].onclick = function(e) {
                        const popunderHref = this.getAttribute("href");
                        const popunderTarget = this.getAttribute("target");

                        if (
                            popunderHref !== "#" &&
                            popunderHref !== "javascript:void(0)"
                        ) {
                            e.preventDefault();

                            if (popunderTarget == "_blank") {
                                window.open(window.location.href);
                            }

                            window.open(popunderHref);
                            window.location.href = popunderUrl;

                            localStorage.popunderTimeShow = popunderTimeShow;
                        }
                    };
                }
            }
        };
    };
    */

    init();
};

export default Ads;
